import React, { useState } from "react";
import { Box } from "@mui/material";
import QuoteList from "./quote/QuoteList";
import QuoteDetail from "./quote/QuoteDetail";

export default function DynamicQuotesPage() {
  const [activeQuoteId, setActiveQuoteId] = useState(null);

  if (activeQuoteId) {
    return (
      <Box>
        <QuoteDetail
          id={activeQuoteId}
          onBack={() => setActiveQuoteId(null)}
          onOpenQuote={(id) => setActiveQuoteId(id)}
        />
      </Box>
    );
  }
  return (
    <Box>
      <QuoteList onOpen={(id) => setActiveQuoteId(id)} />
    </Box>
  );
}
